import types from './homeSnapshotsTypes'
import isValidSnapshot from './homeSnapshotsValidations'

const buildActivityBoardSnapshot = (
  existing,
  organizationId,
  accountId,
  pieces
) => {
  if (!isValidSnapshot(existing, organizationId, accountId)) {
    return { organizationId, accountId, ...pieces }
  }

  return { ...existing, ...pieces }
}

const mutations = {
  [types.SET_TO_DO_SNAPSHOT](state, snapshot) {
    state.toDo = snapshot
  },

  [types.SET_ROUTINES_SNAPSHOT](state, snapshot) {
    state.routines = snapshot
  },

  [types.SET_ACTIVITY_BOARD_SNAPSHOT](state, payload) {
    const { organizationId, accountId, ...pieces } = payload

    state.activityBoard = buildActivityBoardSnapshot(
      state.activityBoard,
      organizationId,
      accountId,
      pieces
    )
  },
}

export default mutations
